import { render, staticRenderFns } from "./SingleMobileWheelOfFortune.vue?vue&type=template&id=d284bfbc&scoped=true&"
import script from "./SingleMobileWheelOfFortune.vue?vue&type=script&lang=js&"
export * from "./SingleMobileWheelOfFortune.vue?vue&type=script&lang=js&"
import style0 from "./SingleMobileWheelOfFortune.vue?vue&type=style&index=0&id=d284bfbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d284bfbc",
  null
  
)

export default component.exports